<formio #formioComponent
        class="formio-material"
        [refresh]="refreshForm"
        [service]="this"
        [renderOptions]="formio_renderOptions"
        [form]="formioConfiguration"
        (ready)="formioReady()"
        (change)="onChange($event)">
</formio>